import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'mail-domains',
    routes: [
        {
            path: '/mail-domains',
            meta: {
                layout: 'app',
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
                permissions: [AppPermissions.ManageMail],
            },
            children: [
                {
                    path: '',
                    name: 'mail domains',
                    component: () => import('#modules/mail-domains/pages/index.vue'),
                },
                {
                    path: ':mailDomain',
                    name: 'show mail domain',
                    component: () => import('#modules/mail-domains/pages/show.vue'),
                },
            ],
        },
    ],
});
